import React from 'react';

interface PushedToDeviceBadgeProps {
  platform: 'garmin' | 'apple_watch';
  deviceModel?: string;
  size?: 'small' | 'medium';
}

export const PushedToDeviceBadge: React.FC<PushedToDeviceBadgeProps> = ({
  platform,
  deviceModel,
  size = 'small',
}) => {
  const iconSize = size === 'small' ? 'h-3.5' : 'h-4'; // 14px or 16px

  const renderPlatformIcon = () => {
    if (platform === 'garmin') {
      return (
        <img
          src="/garmin-assets/Garmin Tag-black-high-res.png"
          alt="Garmin"
          className={iconSize}
        />
      );
    }
    // Apple Watch placeholder - would use Apple Watch logo
    return <span className="text-xs text-gray-600">Watch</span>;
  };

  return (
    <div className="flex items-center gap-1.5 text-xs text-gray-600">
      {renderPlatformIcon()}
      <span className="text-green-600">✓</span>
      {deviceModel ? (
        <span className="text-gray-700">{deviceModel}</span>
      ) : (
        <span className="text-gray-600">Pushed</span>
      )}
    </div>
  );
};

export default PushedToDeviceBadge;






